import 'view/css/susp-log-view.css';

import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { Data } from 'service/util';
import Protected from 'component/Protected';
import Loading from 'component/Loading';

import DatePicker from 'react-datepicker';

const today = moment().startOf('day').toDate();

const SuspensionLogView = (props) =>
{
  const [ls_staff, setStaffList] = useState([]);

  const [from_dtm, setFromDate]   = useState(today);
  const [to_dtm, setToDate]   = useState(today);
  const [company, setCompany] = useState('');
  const [sel_type, setType]   = useState('');

  const [staff_name, setFilterName] = useState('');
  const [exporting, setExporting] = useState(false);

  const [data, setData]     = useState(null);
  const [items, setItems]   = useState(null);

  const updateFilter = (apiData) =>
  {
    if (apiData) setData(apiData);

    // execute filter
    let ls = apiData || data;
    if (!ls) return;
    setStaffList(Array.from(new Set(ls.map(x => x.create_by))));

    if (company) ls = ls.filter(x => x.company == company);
    if (sel_type) {
      let _type = Boolean(sel_type=='0');
      ls = ls.filter(x => x.is_terminate ^ _type);
    }

    let _name = String(staff_name).trim().toUpperCase();
    if (_name) ls = ls.filter(x => -1<String(x.create_by).toUpperCase().indexOf(_name));

    setItems(ls);
  }

  useEffect(() => {
    // display state
    setItems(null);
    // start load data
    let dto = { from_dtm, to_dtm };
    API.getSuspHistByDate(dto).then(resp => {
      if (resp.success) {
        updateFilter(resp.msg);
      } else {
        updateFilter([]);
      }
    });
  }, [from_dtm, to_dtm])

  useEffect(() => {
    updateFilter();
  }, [company, sel_type, staff_name]);

  //----------
  const exportXls = () => {
    if (exporting) return false;
    setExporting(true);
    let fdate = Util.ShortDate(from_dtm);
    let tdate = Util.ShortDate(to_dtm);
    let dto = {
       from_dtm
      ,to_dtm
      ,type: sel_type
      ,company
      ,staff_name
    };
    API.exportSuspensionRecord(dto).then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `${fdate}至${tdate}終止及暫停記錄_${ix_date}.xlsx`);
      setExporting(false);
    });
  }

  return (
    <>
      <h1>紀錄 - 暫停及終止服務紀錄</h1>
      <div className="susp-log-view">
        <div className="action-panel">
          <div className="row search-bar">
            <label className="field-row">
              <strong>建立日期由</strong>
              <DatePicker selected={from_dtm} onChange={setFromDate}
                dateFormat="yyyy-MM-dd" />
            </label>
            <label className="field-row">
              <strong>至</strong>
              <DatePicker selected={to_dtm} onChange={setToDate}
                dateFormat="yyyy-MM-dd" />
            </label>
            <label className="field-row">
              <strong>公司</strong>
              <select value={company} onChange={e=>setCompany(e.target.value)}>
                <option value="">全部</option>
                { Data.company.map(com =>
                  <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                )}
              </select>
            </label>
            <label className="field-row">
              <strong>類型</strong>
              <select value={sel_type} onChange={e=>setType(e.target.value)}>
                <option value="">全部</option>
                <option value="0">暫停</option>
                <option value="1">終止</option>
              </select>
            </label>
            <label className="field-row">
              <strong>負責同事</strong>
              <select value={staff_name} onChange={e=>setFilterName(e.target.value)}>
                <option value="">全部</option>
                { ls_staff.map(s => <option key={s} value={s}>{ s }</option>) }
              </select>
            </label>
          </div>
          <div>
            { items?.length >0 &&
              <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_DAY','VIEWER_NIGHT']}>
                <button className="btn dark-green btn-export" disabled={exporting}
                  onClick={exportXls}>
                  <FontAwesomeIcon icon={faFileExcel} />
                  <span> 匯出</span>
                </button>
              </Protected>
            }
          </div>
        </div>
        <div className="susp-log-view-body">
        { !items ? <Loading/>
          :items.length <= 0 ? <p className="message yellow">沒有記錄</p>
          :<table className="data-table full-width">
            <colgroup>
              <col width="60px"  id="col-susp-log-type" />
              <col width="60px"  id="col-susp-log-company" />
              <col width="100px" id="col-susp-log-license" />
              <col width="60px"  id="col-susp-log-plan" />
              <col width="100px" id="col-susp-log-reg-date" />
              <col width="100px" id="col-susp-log-end-date" />
              <col width="80px"  id="col-susp-log-fee" />
              <col width="80px"  id="col-susp-log-extra-fee" />
              <col width="120px" id="col-susp-log-worker" />
              <col width="120px" id="col-susp-log-reason" />
              <col width="auto"  id="col-susp-log-remarks" />
              <col width="160px" id="col-susp-log-mod-date" />
              <col width="160px" id="col-susp-log-by" />
            </colgroup>
            <thead>
              <tr>
                <th className="col-susp-log-type">類型</th>
                <th className="col-susp-log-company">公司</th>
                <th className="col-susp-log-license">車牌</th>
                <th className="col-susp-log-plan">計劃</th>
                <th className="col-susp-log-reg-date">開戶日期</th>
                <th className="col-susp-log-end-date">結束日期</th>
                <th className="col-susp-log-fee">月費</th>
                <th className="col-susp-log-extra-fee">附加收費</th>
                <th className="col-susp-log-worker">工人</th>
                <th className="col-susp-log-reason">原因</th>
                <th className="col-susp-log-remarks">備註</th>
                <th className="col-susp-log-create-date">紀錄日期</th>
                <th className="col-susp-log-by">負責同事</th>
              </tr>
            </thead>
            <tbody>
              { items.map((x, i) =>
                <tr key={i}>
                  <td className="col-susp-log-type">{ x.is_terminate ? '終止' : '暫停' }</td>
                  <td className="col-susp-log-company">{ Util.getCompanyName(x.company) }</td>
                  <td className="col-susp-log-license">
                    <a href={`/op/services/${x.cd_license}`}>{ x.cd_license }</a>
                  </td>
                  <td className="col-susp-log-plan">{ x.srv_plan }</td>
                  <td className="col-susp-log-reg-date">{ Util.ShortDate(x.reg_dtm) }</td>
                  <td className="col-susp-log-end-date">{ Util.ShortDate(x.end_dtm) }</td>
                  <td className="col-susp-log-fee">${ Util.nf(x.fee) }</td>
                  <td className="col-susp-log-extra-fee">${ Util.nf(x.extra_fee) }</td>
                  <td className="col-susp-log-worker">{ x.worker_name } ({ x.worker })</td>
                  <td className="col-susp-log-reason">{ Util.getReasonType(x.reason_id) }</td>
                  <td className="col-susp-log-remarks">{ x.remarks } </td>
                  <td className="col-susp-log-create-date">{ Util.FullDate(x.create_dtm) }</td>
                  <td className="col-susp-log-by" title={`更新日期: ${Util.ShortDate(x.mod_dtm)}`}>{ x.create_by }</td>
                </tr>
              )}
            </tbody>
          </table>
        }
        </div>
      </div>
    </>
  );
}

export default SuspensionLogView;
